import { render, staticRenderFns } from "./VentilationDevice.vue?vue&type=template&id=5bbd86b6&"
import script from "./VentilationDevice.vue?vue&type=script&lang=js&"
export * from "./VentilationDevice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports